/**
 * フェードイン
 */

// $( function () {
// 	let scrollTop;

// 	function fadeInElements() {
// 		scrollTop = $( window ).scrollTop();
// 	  $('.js-fadein').each(function() {
//       const position = $(this).offset().top;
//       const windowHeight = $(window).height();
//       if ( scrollTop > position - windowHeight + 200 ) {
//         $(this).css({
//           opacity: 1,
//           transform: 'translateY(0)'
//         });
//       }
// 	  });
  
// 	  $('.js-fadein-group').each(function() {
//       const position = $(this).offset().top;
//       const windowHeight = $(window).height();
//       if ( scrollTop > position - windowHeight + 200 ) {
//         $(this).children().each(function(index) {
//           $(this).css({
//             transitionDelay: `${index * 0.2}s`,
//             opacity: 1,
//             transform: 'translateY(0)'
//           });
//         });
// 		  }
// 	  });

// 	  $('.js-fadein-group--fast').each(function() {
//       const position = $(this).offset().top;
//       const windowHeight = $(window).height();
//       if ( scrollTop > position - windowHeight + 200 ) {
//         $(this).children().each(function(index) {
//           $(this).css({
//             transitionDelay: `${index * 0.1}s`,
//             opacity: 1,
//             transform: 'translateY(0)'
//           });
//         });
// 		  }
// 	  });
// 	}
  
// 	$(document).on('scroll', fadeInElements);
// 	$(window).on('load', fadeInElements);

// });

document.addEventListener('DOMContentLoaded', function() {
  // フェードインするための関数
  function fadeIn(entry, delay = 0) {
    if (entry.isIntersecting) {
      const target = entry.target;
      target.style.transitionDelay = `${delay}s`;
      target.style.opacity = 1;
      target.style.transform = 'translateY(0)';
      observer.unobserve(target); // 見えるようになったら監視を停止
    }
  }

  // グループ要素をフェードインするための関数
  function fadeInGroup(entries, delay) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const children = Array.from(entry.target.children);
        children.forEach((child, index) => {
          fadeIn({ target: child, isIntersecting: true }, index * delay);
        });
        observer.unobserve(entry.target); // 見えるようになったら監視を停止
      }
    });
  }

  // IntersectionObserverのオプション
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0
  };

  // フェードインのオブザーバー
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => fadeIn(entry));
  }, options);

  // フェードイングループ（0.2秒遅延）のオブザーバー
  const observerGroup = new IntersectionObserver((entries) => {
    fadeInGroup(entries, 0.2);
  }, options);

  // フェードイングループ（0.1秒遅延）のオブザーバー
  const observerGroupFast = new IntersectionObserver((entries) => {
    fadeInGroup(entries, 0.1);
  }, options);

  // 要素を取得し、オブザーバーに渡す
  document.querySelectorAll('.js-fadein').forEach(element => {
    observer.observe(element);
  });

  document.querySelectorAll('.js-fadein-group').forEach(element => {
    observerGroup.observe(element);
  });

  document.querySelectorAll('.js-fadein-group--fast').forEach(element => {
    observerGroupFast.observe(element);
  });
});
